import api from '@/services/api';
import { login as loginRequest } from '@/services/auth';

const state = {
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user')) || null,
};

const getters = {
  isAuthenticated: state => !!state.token,
  user: state => state.user,
};

const mutations = {
  SET_AUTH(state, { token, user }) {
    state.token = token;
    state.user = user;

    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));

    api.defaults.headers.Authorization = `Bearer ${token}`;
  },

  LOGOUT(state) {
    state.token = null;
    state.user = null;

    localStorage.removeItem('token');
    localStorage.removeItem('user');

    delete api.defaults.headers.Authorization;
  },
};

const actions = {
  async login({ commit }, credentials) {
    const { data } = await loginRequest(credentials);

    commit('SET_AUTH', {
      token: data.token,
      user: data.user,
    });
  },

  logout({ commit }) {
    commit('LOGOUT');
  },

  loadSession({ commit, state }) {
    if (state.token) {
      api.defaults.headers.Authorization = `Bearer ${state.token}`;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
